import React from 'react';
import GitHubIcon from '@mui/icons-material/GitHub';
import EmailIcon from '@mui/icons-material/Email';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import "./styles.css";

export const ConnectComponent = () => (
	<React.Fragment>
		<div className='connect'>
            <div className='connectTitle'>
                Let's Connect!
            </div>
            <div className='connectContent'>
                If you have anything to tell me or just want to say hi 👋, feel free to reach out at anytime 🙂.
            </div>
            <div style={{textAlign: "center", paddingBottom: "200px", paddingTop: "20px", display: "flex", flexDirection: "row", justifyContent: "center", flexWrap: "wrap", width: "100%", alignItems: "center"}}>
                <div style={{display: "flex", flexDirection: "column", width: "33%", minWidth: "200px"}}>
                    <a href="https://github.com/cjwku1209"><GitHubIcon style={{color: "white", fontSize: "50px", margin: "20px"}}/></a>
                    cjwku
                </div>
                <div style={{display: "flex", flexDirection: "column", width: "33%", minWidth: "200px"}}>
                    <a><EmailIcon style={{color: "white", fontSize: "50px", margin: "20px", }}/></a>
                    calvinku1209@gmail.com
                </div>
                <div style={{display: "flex", flexDirection: "column", width: "33%", minWidth: "200px"}}>
                    <a href='https://www.linkedin.com/in/calvin-ku-12-09/'><LinkedInIcon style={{color: "white", fontSize: "50px", margin: "20px"}}/></a>
                    calvin-ku-12-09
                </div>
                
            </div>
        </div>
            
	</React.Fragment>
);